/**
 * Executes an action and logs it in development mode.
 */
import { logger } from "@/utils/logger/logger";

export const executeSafely = <R>(actionDescription: string, actionFn: () => R): R => {
  logger.log(`[DEV] ${actionDescription}`);
  return actionFn();
};
